export const conflictingSources: string[] = [
  'One video tells you one thing.',
  'Another website tells you something different.',
]

export const symptoms: string[] = [
  'Then your leaves start turning yellow.',
  'Your roots don’t look right.',
  'Your pH keeps changing.',
  'Your plants stop growing.',
]

export const searchQuestions: string[] = [
  'Which hydroponic system should I use?',
  'How much nutrient solution does the plant need?',
  'Is my pH correct?',
  'What should my EC be?',
  'Are these roots healthy?',
  'Is the light too close?',
  'Why are the leaves changing color?',
  'When should I harvest?',
  'What do I check first when something goes wrong?',
]

export const painPoints: string[] = [
  'Buying equipment you didn’t actually need.',
  'Choosing the wrong system for your space.',
  'Mixing nutrients without understanding what you’re measuring.',
  'Constantly changing pH without understanding why.',
  'Overcrowding plants.',
  'Using the wrong lighting conditions.',
  'Ignoring early root problems.',
  'Losing plants before harvest.',
  'Starting crops that don’t match your setup.',
  'Searching online every time something looks wrong.',
  'Starting over because you don’t know what failed.',
]

export const systemShows: string[] = [
  'WHAT TO BUILD.',
  'WHAT TO CHECK.',
  'WHAT TO GROW.',
  'WHAT HEALTHY LOOKS LIKE.',
  'WHAT TO DO WHEN SOMETHING GOES WRONG.',
]
